import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AppNotice } from './app-notice.reducer';
import {
  CreateApplicationNoticeInput,
  UpdateApplicationNoticeInput,
  CheckApplicationNoticeConflictInput,
} from '@graphql/bifrost/generated';
import { Update } from '@ngrx/entity';

export const appNoticeActions = createActionGroup({
  source: 'AppNotice',
  events: {
    LoadOne: props<{ id: number }>(),
    LoadOneSuccess: props<{ notice: AppNotice }>(),
    LoadOneFailure: props<{ error: any }>(),
    LoadAll: emptyProps(),
    LoadAllSuccess: props<{ notices: AppNotice[] }>(),
    LoadAllFailure: props<{ error: any }>(),
    LoadActive: emptyProps(),
    LoadActiveSuccess: props<{ notice: AppNotice }>(),
    LoadActiveFailure: props<{ error: any }>(),
    Create: props<{ input: CreateApplicationNoticeInput }>(),
    CreateSuccess: props<{ notice: AppNotice }>(),
    CreateFailure: props<{ error: any }>(),
    Update: props<{ input: UpdateApplicationNoticeInput }>(),
    UpdateSuccess: props<{ notice: Update<AppNotice> }>(),
    UpdateFailure: props<{ error: any }>(),
    CheckConflict: props<{ input: CheckApplicationNoticeConflictInput }>(),
    CheckConflictSuccess: props<{
      conflictingNotice?: { title: string; startTime: string; endTime: string };
    }>(),
    CheckConflictFailure: props<{ error: any }>(),
  },
});
